<template>
  <div class="mb-2">
    <h4 v-if="!isRegistering" class="mb-3">{{ $t(LangConstants.company_settings_step_label) }}</h4>
    <div class="container justify-content-center form-base">
      <b-form ref="frmBasicData" @submit.stop.prevent="proceedBtnHandler">
        <div class="col-12 form1">
          <div class="row mb-2">
            <div class="col-md-6 mb-2">
              <selector id="team-lead-sel" :label="$t(LangConstants.team_lead_label)" :selected="company.team_lead_userid" name="team-lead-sel" mandatory="false" :data="userList" valuefield="id" textfield="name" inlinerows="false" classes="bg-gray" blockClasses="" blockLabelClass="col-md-12 pl-0 pr-0 mb-0" ref="teamLeadSelector" v-model="company.team_lead_userid"></selector>
              <span class="mb-5 p-1"><i><a :href="roleAssignmentUrl">{{$t(LangConstants.add_user_link_label)}}</a></i></span>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-md-3">
              <toggle-simple :labelEnable="$t(LangConstants.yes_text)" v-model="company.allow_invoice" :label="$t(LangConstants.allow_invoice_label)" margins="mb-0" :labelDisable="$t(LangConstants.no_text)" :checked="company.allow_invoice == true" ref="isAllowedInvoice" @toggle="changeAllowInvoice"></toggle-simple>
            </div>
            <div class="col-md-3 mb-2">
              <my-input id="max-license" name="max-license" mandatory="true" v-model="company.maximum_license" :label="$t(LangConstants.max_allowed_licenses_label)" inlinerows="false" classes="bg-gray" ref="maxLicense" type="text"></my-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 mb-4">
              <my-input id="discount" name="discount" mandatory="true" maxLength="100" minLength="0" v-model="company.discount" :label="$t(LangConstants.discount_label)" :placeholder="$t(LangConstants.discount_placeholder)" inlinerows="false" classes="bg-gray" ref="discount" type="number"></my-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 mb-4">
              <my-button fa="save" :label="!isRegistering ? $t(LangConstants.save_changes_button_label) : $t(LangConstants.save_company_button_label)" variant="solid-primary" classes="mr-1" height="56px" width="100%" type="submit"></my-button>
            </div>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import Constants from "../../constants/index";
import MyInput from "../../components/atoms/Input.vue";
import MyButton from "../../components/atoms/Button.vue";
import ToggleSimple from "../../components/atoms/ToggleSimple.vue";
import Selector from "../../components/atoms/Selector.vue";

import "../../assets/scss/common.scss";

export default {
  name: "company-settings",

  data() {
    return {
      company: this.$props.companyForm,
    };
  },

  mounted() {
    this.$refs.maxLicense.text = this.company.maximum_license;
    this.$refs.discount.text = this.company.discount;
  },

  props: {
    companyForm: {
      required: true
    },
    users: {
      required: true,
    },
    isRegistering: {
      type: Boolean,
      default: false
    }
  },

// watch: {
//   companyForm: function (newCompanyForm) {
//     console.log(2);
//     console.log(newCompanyForm);
//     this.$refs.maxLicense.text = newCompanyForm.maximum_license;
//     this.$refs.discount.text = newCompanyForm.discount;
//     this.$refs.teamLeadSelector.text = null;
//     this.company.allow_invoice = false;
//   }
// },

  computed: {
    LangConstants() {
      return Constants;
    },

    userList() {
      return this.users.map((user) => {
        return { id: user.userid, name: user.first_name+" "+user.last_name+" ("+user.email+")"}
      });
    },

    roleAssignmentUrl() {
      return window.location.origin+'/admin/roles/assign.php?contextid=1';
    }
  },

  methods: {
    proceedBtnHandler() {
      this.$emit("save", this.company);
    },

    changeAllowInvoice(isChecked) {
      this.company.allow_invoice = isChecked;
    }
  },

  components: {
    MyInput,
    MyButton,
    ToggleSimple,
    Selector
  },
};
</script>
